import { Box } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import { DropdownMenu, Table, TableBody, theme } from '@dtx-company/shared-components/src'
import { DropdownMenuItems } from './styles'
import { PriceTier } from '@dtx-company/flow-codegen/src/code/generated.types'
import { ProductQuantityItems } from './product-quantity-items'
import { ProductQuantityProps } from '../../../types/print-store.types'
import { Text } from '@dtx-company/shared-components/src/components/atoms/Text/index'
import { getPriceForQuantity } from '../../../utils/print-store'
import events from '@dtx-company/inter-app/src/event-tracking/events/printStore'

export const ProductQuantity = ({
  product,
  disabled,
  handleInputChange,
  quantity,
  title,
  width,
  dropdownMenuWidth,
  dropdownMenuItemsProps,
  customMarginRight = '0px',
  customMinWidth = 'unset'
}: ProductQuantityProps & { customMarginRight?: string; customMinWidth?: string }): JSX.Element => {
  const minUnitAmount = product?.priceModel?.sortedTiers?.[0]?.unitAmount ?? 0

  const handleQuantity = (selectedQuantity: PriceTier['quantity'], savedValue?: number): void => {
    const itemsPrice = getPriceForQuantity(product, selectedQuantity)
    handleInputChange({
      quantity: selectedQuantity,
      itemsSubTotal: itemsPrice.price,
      unitAmount: itemsPrice.unitAmount,
      savedValue
    })
    events.Print_Store_PDP_Selected_Product_Quantity(product?.id ?? '', quantity ?? 0)
  }
  const dropdownMenuItemsWidth = dropdownMenuWidth ?? width

  return (
    <>
      {title && (
        <Box width={{ _: '100%', md: 'auto' }} gridArea={{ md: 'qtyLabel' }}>
          <Text
            variant={{ _: 'body/medium', md: 'body/small', xl: 'body/medium' }}
            data-testid="quantity-label"
            marginBottom={{ xs: '8px', md: 0 }}
            minWidth={customMinWidth}
            mr={customMarginRight}
          >
            {title}
          </Text>
        </Box>
      )}

      <Box
        width={{ _: '100%', md: 'auto' }}
        gridArea={{ md: 'qtyContent' }}
        marginBottom={{ _: '17px', md: 0 }}
      >
        <DropdownMenu
          header={
            <Text variant="body/medium" aria-label={`selected-quantity-${quantity}`}>
              {quantity}
            </Text>
          }
          width={width}
          padding="8px 34px 8px 12px"
          borderRadius="4px"
          disabled={disabled}
          backgroundColor={'primary.white'}
          height="44px"
          alignItems="center"
        >
          <DropdownMenuItems
            width={dropdownMenuItemsWidth}
            maxHeight="202px"
            flexDirection="column"
            marginTop="6px"
            position="absolute"
            backgroundColor="primary.white"
            border={`1px solid ${theme.colors.secondary.border}`}
            borderRadius="0px 8px 8px 8px"
            right="auto"
            left={0}
            zIndex={7}
            overflow="scroll"
            {...dropdownMenuItemsProps}
          >
            <Table borderCollapse="separate" backgroundColor="transparent">
              <TableBody>
                {product?.priceModel?.sortedTiers?.map(item => (
                  <ProductQuantityItems
                    key={item?.quantity}
                    tier={item}
                    handleQuantity={handleQuantity}
                    selectedQuantity={quantity}
                    minUnitAmount={minUnitAmount}
                  />
                ))}
              </TableBody>
            </Table>
          </DropdownMenuItems>
        </DropdownMenu>
      </Box>
    </>
  )
}
